import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { SUPPORTED_ELEC_MODULES } from '@pages/control-page/control-page.const';
import { map } from 'rxjs';

@Component({
  selector: 'app-cp-compare-sidebar-home',
  templateUrl: './cp-compare-sidebar-home.component.html',
  styleUrls: ['./cp-compare-sidebar-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareSidebarHomeComponent {

  hasElec$ = this.modulesFacade.currentHomeModules$.pipe(
    map(modules => modules.some(m => SUPPORTED_ELEC_MODULES.includes(m.type)))
  );

  constructor(
    private modulesFacade: ModulesFacade,
  ) {}

}
